import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import logger from "../../../../../utils/logger";
import { addUser,getUser } from "../../../../controller/reducer/user";

const UserAddModal = ({ show, onClose, dispatch }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const user = useSelector(getUser);
  const [type, setType] = useState("admin");
  const submitTask = (e) => {
    e.preventDefault();
    const data = {
      name,
      password,
      email,
      type,
    };
    logger()(data);
    dispatch(addUser(data));
    onClose();
  };
  return (
    <Modal show={show} animation={false} onHide={onClose}>
      <Modal.Header>
        <Modal.Title>Add New User</Modal.Title>
      </Modal.Header>
      <Form onSubmit={submitTask}>
        <Modal.Body>
          <Form.Group controlId="name">
            <Form.Label>Enter Name*</Form.Label>
            <Form.Control
              maxLength="200"
              required
              type="text"
              placeholder="Name"
              value={name}
              onChange={(e) => setName(e.currentTarget.value)}
            />
          </Form.Group>
          <Form.Group controlId="email">
            <Form.Label>Enter Email*</Form.Label>
            <Form.Control
              maxLength="50"
              type="email"
              required
              placeholder="Email Here"
              value={email}
              onChange={(e) => setEmail(e.currentTarget.value)}
            />
          </Form.Group>
          <Form.Group controlId="password">
            <Form.Label>Enter Password*</Form.Label>
            <Form.Control
              required
              type="text"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.currentTarget.value)}
            />
          </Form.Group>
          <Form.Group controlId="type">
            <Form.Label>Enter Type*</Form.Label>
            <Form.Control
              required
              as="select"
              className="mr-sm-2"
              value={type}
              onChange={(e) =>setType(e.target.value)}
            >
              <option value="admin">Admin</option>
              <option value="super">Super</option>
             {user.type==="root" && <option value="root">Root</option>}
            </Form.Control>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" type="submit">
            Submit
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default UserAddModal;
